import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class GrundstueckBeschreibungLocationStrategy extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'GRUNDSTUECK_DETAIL_BESCHREIBUNG';
  }
}
